import React, { useState, useRef, useEffect } from 'react';
import {useDispatch} from 'react-redux';

import ConfidenceFlagDropdown from './confidence-flag-dropdown.component';
import GoalServices from "../../services/goal.services";
import { krdetailActions } from "../../actions/krDetails.actions";
import { commentActions } from "../../actions/comment.actions";
import { krdetailConstants } from "../../constants/krdetails.constants";
import { updateKRConst } from "../../constants/updateKR.constants";
import { CKEditor } from '@ckeditor/ckeditor5-react'
import CKEDITOR from '@workboard/ckeditor5-build-wobo'
import EmojiContainer from '../emojis/emojis';
import { useTranslation } from 'react-i18next';

export default function ConfidenceKRPopup({ open, close, confidence, metricId, goalId, cascadeId, headerTitle = false, fromUpdate= false,updateOkrPop=null, onSaveConf=""  }) {
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [emptyError, setEmptyError] = useState(false);
  const [selectedText, setSelectedText] = useState(confidence.confidenceLabel ? confidence.confidenceLabel : '');
  const [commentText, setCommentText] = useState(confidence.comment ? confidence.comment : "");
  const commentRef = React.createRef();
  const buttonRef = React.useRef(null);
  const [ck_editor, setEditor] = useState(null);
  const nodeRef = useRef();
  const {t} = useTranslation();
  const onChangeConfidence = (text) => {
    setSelectedText(text);
  }
  const goalServices = new GoalServices();

  // Custom Keyboard Focus Trap Handler
  const keyDownHandler = (e) => { 
    // On Esc, Close the modal
    if (e.key === 'Escape') {                 
      if(!$("#confidenceDropdown").length) close();
      return;
    }
    // only execute if tab is pressed
    if (e.key !== 'Tab') return;
    // Query - Array - all focusable elements
    const focusableModalElements = nodeRef.current.querySelectorAll(
      'div[contenteditable], a[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button'
    )
    const firstElement = focusableModalElements[0]
    const lastElement = focusableModalElements[focusableModalElements.length - 1]
    if (!e.shiftKey && document.activeElement === lastElement) {
      firstElement.focus()
      return e.preventDefault()
    }
    // if going backward by pressing tab and firstElement is active shift focus to last focusable element 
    if (e.shiftKey && document.activeElement === firstElement) {
      lastElement.focus()
      e.preventDefault()
    }
  }

  // To focus the modal on initial render
  useEffect(()=>{
    if(buttonRef) buttonRef.current.focus();
    if(confidence.comment) setCommentText(confidence.comment);
  }, [])

  useEffect(() => {
    //window.addEventListener("click", handleClickOutside, true);
    window.addEventListener('keydown', keyDownHandler, true);
    return () => {
     // window.removeEventListener("click", handleClickOutside, true);
      window.removeEventListener('keydown', keyDownHandler, true);
    }
  }, []);

  const handleClickOutside = (e) => { 
    if (nodeRef && !nodeRef.current.contains(e.target)) {
      close();
    }
  }
  
  const disableClick = (e) => e.stopPropagation();
  
  const removeError = () => {
    setEmptyError(false);
    setError(false);
  }
  const saveConfidence = () => {
    if (commentText == '') {
      setEmptyError(false);
      setError(false);
      if (selectedText == '' || selectedText == 'No Rating') {
        setEmptyError(true);
      } else setError(true);
      commentRef.current.focus(); //Sent focus back to comments on error
      return;
    }
    if (commentText != '') {
      let selectedConfidence = 0;
      if (selectedText == 'Low') {
        selectedConfidence = 1;
      } else if (selectedText == 'Medium') {
        selectedConfidence = 2;
      } else if (selectedText == 'High') {
        selectedConfidence = 3;
      }
      let params = {};
      params.obj_id = metricId;
      params.confidence = selectedConfidence;
      params.comment = commentText;
      params.confidence_comment = 1;
      if(confidence.id) {
        params.id = confidence.id;
      }

      // disable button clicks during API call to prevent synchronization issue when 
      // user click on save button on parent modal before API call is completed (WW-17709)
      window.removeEventListener("click", handleClickOutside, true);
      window.addEventListener("click", disableClick, true);

      goalServices.setConfidenceRating(params)
        .then(response => {
          var data = {};
        if (response.data && response.data.comments) {
          data.added_by =  response.data.comments[0].commentOwnerId;
          data.added_by_name = response.data.comments[0].commentOwnerName;
          data.comment = response.data.comments[0].comment;
          data.confidence = response.data.comments[0].confidence;
          data.created_at = response.data.comments[0].create_at;
          data.id = response.data.comments[0].id;
          data.confidenceLabel =  response.data.comments[0].confidenceLabel;
          data.created_at_formatted = response.data.comments[0].created_at_formatted;
          data.metricId = response.data.comments[0].metric_id;
          if (headerTitle) {
            // multiple kr's update page - update confidence icon details on save 
          dispatch({
            type: krdetailConstants.GET_UPDATE_KR_CONFIDENCE, 
            data
          });
            onSaveConf();
          } else {
              // KR details page - update activity section and header confidence icon
              dispatch(krdetailActions.updatekrHeaderConfidence(data));
              // dispatch(commentActions.fetchCommentList(goalId,metricId));
              dispatch(commentActions.updateCommentConfidence(response.data.comments[0]));
              if(fromUpdate) {
                updateOkrPop(data);
                dispatch({
                  type: updateKRConst.UPDATE_CONFIDENCE,
                  data
                });
                if (window.location.href.includes('/goal/updateMyKR')) {
                  loadUpdateKrsPage();
                } else {
                  const metricParams = {
                    metricGoalId: goalId,
                    metricId: metricId,
                    metricUpdate:'',
                    nextMetricId: '',
                    metricTeamOpen: '',
                    cascadeGoalId: cascadeId,
                  };
                  metricDataSaveAfterAjax(undefined, undefined, metricParams);
                }
            }
          }
        }
        // kr update page 
        })
        .finally(
          () => {
            window.removeEventListener("click", disableClick, true);
            close();
          }
        );
    }
  }
  
  return (
    <div ref={nodeRef}>
      {
        open &&
        <div className="confidencePopupWrapper" ref={buttonRef} role="dialog" 
          aria-label="confidence-dialog"
          aria-modal="true" tabIndex={0} >
          <div>
            {headerTitle &&
              <div className="confidenceFormElement" data-testid="confidenceFormElement-testid">
                <span className="header-text">{t("Previous confidence ratings are visible in Activity history.")}</span>
              </div>
            }
            <div className="confidenceFormElement" data-testid="confidenceFormElement-testid">
              <ConfidenceFlagDropdown
                onChange={onChangeConfidence}
                defaultText={confidence.confidenceLabel?confidence.confidenceLabel:''}
              />
            </div>
            <div className="confidenceFormElement" data-testid="confidenceFormElement-testid">
              <label id="commentsText" data-testid="commentsText-testid">
               {t("Comment")} <span className="star">*</span>
              </label>
              {/* <textarea
                className={(error || emptyError) ? 'confidenceErrorText confidenceCommentText' : 'confidenceCommentText'}
                placeholder="Please include your comment for the confidence rating selection"
                ref={commentRef}
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                onKeyUp={removeError}
                aria-labelledby="commentsText"
                style={{borderStyle:"none", resize:"none"}}
                aria-required="true"
              /> */}
              <p className={(error || emptyError) ? 'confidenceErrorText confidenceCommentText' : 'confidenceCommentText'}>
                <CKEditor 
                ref={commentRef}
                  editor={CKEDITOR.BalloonEditor}
                  data={ commentText }
                  config={{
                    licenseKey: window.ckeditorLicenseKey,
                    placeholder:t("Please include your comment for the confidence rating selection"),
                    toolbar: {
                    items: [ 'bold', 'italic', 'link', 'undo', 'numberedList', 'bulletedList', 'strikethrough', 'underline', 'horizontalLine' ]
                    },
                    plugins: [...CKEDITOR.BalloonEditor.builtinPlugins],
                  }}
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setCommentText(data);
                    if(data != '')
                    removeError();
                  }}
                  onReady={editor => {
                    setEditor(editor);
                  }}
                />
                <EmojiContainer
                    ck_editor={ck_editor}
                />
              </p>
              {
                error &&
                <div role="alert" className="error-text commentError">
                  <span className="icon icon-outline-error_outline-14px-red"></span>
                  <span className="error-text-msg" data-testid="confidence-error-test-msg">{t("A comment is required when rating confidence.")}</span>
                </div>
              }
              {
                emptyError &&
                <div role="alert" className="error-text commentError">
                  <span className="icon icon-outline-error_outline-14px-red"></span>
                  <span className="error-text-msg" data-testid="confidence-error-test-msg">{t("Please select an option and provide a comment to save.")}</span>
                </div>
              }
              <label style={{paddingTop:"8px",color:"unset"}}>{t("All fields marked with * are required")}</label>
            </div>
            <div className="confidenceButtonWrapper">
            <button type="button" onClick={close} style={{border:'0', lineHeight:"30px"}} className="confidenceCancel">{t("Cancel")}</button>
            <button type="button" onClick={saveConfidence} style={{border: '0'}} className="confidenceSave" data-testid="confidenceSave-testid">{t("Save")}</button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}